<section class="content-header">
    <div class="container-fluid">
        <div class="row ">
            <div class="col-sm-6">
                <h1>Report</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a routerLink="/main">Home</a></li>
                    <li class="breadcrumb-item active">Dashboard</li>
                </ol>
            </div>
        </div>
    </div>
</section>

<section class="content mycontent" style="margin-top: 30px; margin-left: 30px; margin-right: 30px;">
    <div class="container-fluid">
        <ng-container *ngIf="layoutEnabled == 'layout7'">
            <ng-container *ngTemplateOutlet="layout7"></ng-container>
        </ng-container>

        <aside class="control-sidebar control-sidebar-dark"></aside>
    </div>
</section>

<ng-template #layout7>


    <div class="row mt-3">
        <div class="row">

            <section class="col-md-12 mb-1 connectedSortable">
                <div class="small-box bg-box-green p-1" style="height: 90%;">
                    <div class="row">
                        <div class="col-9" style="font-style: italic; text-align: center;">
                            <p class="mt-1" style="font-size: 11.3pt;font-weight: normal;"><b>PROGETTO
                                    ARKETIPO - INTELLIGENZA ARTIFICIALE PER LA DIAGNOSI PRECOCE DI SCOMPENSO CARDIACO
                                    MEDIANTE ANALISI CONGIUNTA DI MARCATORI EPIGENETICI E CLINICI</b>
                                <br>
                                N. progetto MISE F/310107/01-05/X56 – CUP: B59J23000260005
                            </p>
                        </div>
                        <div class="col-3">
                            <img class="mt-1" src="assets/img/loghi.png" alt="" style="width:100%;">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="text-align: center;">
                            <p style="font-size: 14pt;font-weight: normal;">
                                <b>Studio clinico - Report monitoraggio paziente</b>
                            </p>
                        </div>

                    </div>

                </div>
            </section>

            <section class="col-md-12 mb-1 connectedSortable">
                <div class="small-box bg-box-green p-2 pr-4 pl-4" style="height: 100%;margin-top: -10px;">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h3 style="font-size: 20px;color:#1F2937;text-align: center;">Scheda paziente</h3>
                        </div>

                        <ng-container *ngFor="let row of json_generale.dettagli_paziente; let last = last">
                            <div class="col-12 row card-element-row patient-row">
                                <div class="patient-label">
                                    <p>{{ row.label }}</p>
                                </div>
                                <div class="patient-value">
                                    <p>{{ row.value || 'NC' }}</p>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="!last">
                                <p-divider styleClass="custom-p-divider"></p-divider>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>


            <section class="col-md-6 mb-3 connectedSortable">
                <div class="small-box bg-box-green p-2 pr-4 pl-4 " style="height: 100%;">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h3 style="font-size: 20px;color:#1F2937;text-align: center;">
                                Sintomi registrati a visita
                            </h3>
                        </div>

                        <div class="col-12 card-element-row lab-row lab-header">
                            <div class="lab-label">
                                <p>&nbsp;</p>
                            </div>
                            <div class="lab-values">
                                <div class="value"><b>PV</b></div>
                                <div *ngIf="flagFU" class="arrow">→</div>
                                <div *ngIf="flagFU" class="value"><b>FU</b></div>
                                <div *ngIf="flagUV" class="arrow">→</div>
                                <div *ngIf="flagUV" class="value"><b>UV</b></div>
                            </div>
                        </div>

                        <ng-container *ngFor="let row of json_generale.sintomi_visita; let last = last">
                            <div class="col-12">
                                <div class="card-element-row lab-row">
                                    <div class="lab-label">
                                        <p>{{ row.label }}</p>
                                    </div>
                                    <div class="lab-values">
                                        <div class="value">
                                            <img [src]="getFaceIcon(splitValue(row.value)[0])"
                                                alt="{{splitValue(row.value)[0]}}" class="face-icon" />

                                        </div>
                                        <div *ngIf="flagFU" class="arrow">→</div>
                                        <div *ngIf="flagFU" class="value">
                                            <img [src]="getFaceIcon(splitValue(row.value)[0])"
                                                alt="{{splitValue(row.value)[0]}}" class="face-icon" />

                                        </div>
                                        <div *ngIf="flagUV" class="arrow">→</div>
                                        <div *ngIf="flagUV" class="value">
                                            <img [src]="getFaceIcon(splitValue(row.value)[0])"
                                                alt="{{splitValue(row.value)[0]}}" class="face-icon" />

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="!last">
                                <p-divider styleClass="custom-p-divider"></p-divider>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>


            <section class="col-md-6 mb-3 connectedSortable">
                <div class="small-box bg-box-green p-2 pr-4 pl-4" style="height: 100%;">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h3 style="font-size: 20px;color:#1F2937;text-align: center;">Parametri vitali registrati a
                                visita</h3>
                        </div>

                        <div class="col-12 card-element-row lab-row lab-header">
                            <div class="lab-label">
                                <p>&nbsp;</p>
                            </div>
                            <div class="lab-values">
                                <div class="value"><b>PV</b></div>
                                <div *ngIf="flagFU" class="arrow">→</div>
                                <div *ngIf="flagFU" class="value"><b>FU</b></div>
                                <div *ngIf="flagUV" class="arrow">→</div>
                                <div *ngIf="flagUV" class="value"><b>UV</b></div>
                            </div>
                        </div>

                        <ng-container *ngFor="let row of json_generale.parametri_visita; let last = last">
                            <div class="col-12">
                                <div class="card-element-row lab-row">
                                    <div class="lab-label">
                                        <p>{{ row.label }}</p>
                                    </div>
                                    <div class="lab-values">
                                        <div class="value">{{ formatValue(row.label, splitValue(row.value)[0]) }}</div>
                                        <div *ngIf="flagFU" class="arrow">→</div>
                                        <div *ngIf="flagFU" class="value">{{ formatValue(row.label,
                                            splitValue(row.value)[1]) }}</div>
                                        <div *ngIf="flagUV" class="arrow">→</div>
                                        <div *ngIf="flagUV" class="value">{{ formatValue(row.label,
                                            splitValue(row.value)[2]) }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="!last">
                                <p-divider styleClass="custom-p-divider"></p-divider>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>

            <section class="col-md-6 mb-3 connectedSortable">
                <div class="small-box bg-box-green p-2 pr-4 pl-4" style="height: 100%;">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h3 style="font-size: 20px; color:#1F2937; text-align: center;">Farmaci</h3>
                        </div>

                        <!-- Nessun farmaco registrato -->
                        <div class="col-12 text-center mt-2"
                            *ngIf="!json_generale.farmaci || json_generale.farmaci.trim() === ''">
                            <p style="font-size: 14pt;">Non sono stati registrati farmaci.</p>
                        </div>

                        <!-- Layout 1 colonna se <= 8 -->
                        <div class="col-12"
                            *ngIf="json_generale.farmaci && json_generale.farmaci.split(';').length <= 8 && json_generale.farmaci.trim() !== ''">
                            <ng-container *ngFor="let nome of json_generale.farmaci.split(';'); let last = last">
                                <ng-container *ngIf="nome.trim()">
                                    <div class="farmaco-singolo">
                                        <p>{{ nome.split(',')[0].trim() }}</p>
                                    </div>
                                    <p-divider *ngIf="!last" styleClass="custom-p-divider"></p-divider>
                                </ng-container>
                            </ng-container>
                        </div>

                        <!-- Layout 2 colonne se > 8 -->
                        <div class="col-12 row farmaci-row"
                            *ngIf="json_generale.farmaci && json_generale.farmaci.split(';').length > 8 && json_generale.farmaci.trim() !== ''">
                            <!-- Colonna sinistra -->
                            <div class="farmaci-col">
                                <ng-container
                                    *ngFor="let nome of json_generale.farmaci.split(';').slice(0, 8); let last = last">
                                    <ng-container *ngIf="nome.trim()">
                                        <div class="farmaco-singolo">
                                            <p>{{ nome.split(',')[0].trim() }}</p>
                                        </div>
                                        <p-divider *ngIf="!last" styleClass="custom-p-divider"></p-divider>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <!-- Colonna destra -->
                            <div class="farmaci-col">
                                <ng-container
                                    *ngFor="let nome of json_generale.farmaci.split(';').slice(8); let i = index; let last = last">
                                    <ng-container *ngIf="nome.trim()">
                                        <div class="farmaco-singolo">
                                            <p>{{ nome.split(',')[0].trim() }}</p>
                                        </div>
                                        <p-divider *ngIf="!(last && (i + 8 === 15))"
                                            styleClass="custom-p-divider"></p-divider>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="col-md-6 mb-3 connectedSortable">
                <div class="small-box bg-box-green p-2 pr-4 pl-4" style="height: 100%;">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h3 style="font-size: 20px;color:#1F2937;text-align: center;">Esami di laboratorio</h3>
                        </div>

                        <div class="col-12 card-element-row lab-row lab-header">
                            <div class="lab-label">
                                <p>&nbsp;</p>
                            </div>
                            <div class="lab-values">
                                <div class="value"><b>PV</b></div>
                                <div *ngIf="flagFU" class="arrow">→</div>
                                <div *ngIf="flagFU" class="value"><b>FU</b></div>
                                <div *ngIf="flagUV" class="arrow">→</div>
                                <div *ngIf="flagUV" class="value"><b>UV</b></div>
                            </div>
                        </div>

                        <ng-container *ngFor="let row of json_generale.laboratorio_visita; let last = last">
                            <div class="col-12">
                                <div class="card-element-row lab-row">
                                    <div class="lab-label">
                                        <p>{{ row.label }}</p>
                                    </div>
                                    <div class="lab-values">
                                        <div class="value">{{ formatValue(row.label, splitValue(row.value)[0]) }}</div>
                                        <div *ngIf="flagFU" class="arrow">→</div>
                                        <div *ngIf="flagFU" class="value">{{ formatValue(row.label,
                                            splitValue(row.value)[1]) }}</div>
                                        <div *ngIf="flagUV" class="arrow">→</div>
                                        <div *ngIf="flagUV" class="value">{{ formatValue(row.label,
                                            splitValue(row.value)[2]) }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="!last">
                                <p-divider styleClass="custom-p-divider"></p-divider>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>


            <section class="col-md-12 mb-1 connectedSortable">
                <div class="small-box bg-box-green pl-3 pr-3">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <h3 style="font-size: 20px;color:#1F2937;text-align: left;">Legenda:</h3>

                            <!-- Parte sinistra: PV, FU, UV -->
                            <div class="legend-row">
                                <div class="legend-left">
                                    <p><b>PV</b> = <i>Prima visita</i></p>
                                    <p><b>FU</b> = <i>Follow up</i></p>
                                    <p><b>UV</b> = <i>Ultima visita</i></p>
                                </div>

                                <!-- Parte destra: faccine -->
                                <div class="legend-right">
                                    <div class="legend-item">
                                        <img src="assets/img/IconaG0.png" alt="G0" class="face-icon">
                                        <span>= Sintomo assente</span>
                                    </div>
                                    <div class="legend-item">
                                        <img src="assets/img/IconaG1.png" alt="G1" class="face-icon">
                                        <span>= Sintomo lieve</span>
                                    </div>
                                    <div class="legend-item">
                                        <img src="assets/img/IconaG2.png" alt="G2" class="face-icon">
                                        <span>= Sintomo moderato</span>
                                    </div>
                                    <div class="legend-item">
                                        <img src="assets/img/IconaG3.png" alt="G3" class="face-icon">
                                        <span>= Sintomo severo</span>
                                    </div>
                                    <div class="legend-item">
                                        <img src="assets/img/IconaG4.png" alt="G4" class="face-icon">
                                        <span>= Sintomo grave</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section class="col-md-12 connectedSortable" style="height: 30px;margin-bottom: -20px">
                <div class="small-box bg-box-green pr-2 pl-2">
                    <div class="row">
                        <div class="col-12" style="font-style: italic; text-align: center;">
                            <p class="mt-1" style="font-size: 11.3pt;font-weight: normal;">ll presente report
                                rappresenta la sintesi
                                del percorso di
                                monitoraggio all’interno del
                                progetto ARKETIPO. <br>
                                La ringraziamo per la partecipazione e per la preziosa collaborazione, che ha
                                reso possibile il completamento dello studio. </p>
                        </div>
                    </div>

                </div>
            </section>


        </div>
    </div>
</ng-template>